import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import type { Placement } from 'react-bootstrap/types';
import type { OverlayDelay } from 'react-bootstrap/OverlayTrigger';

export default (props: {
  label: string;
  title?: string;
  placement?: Placement;
  delay?: OverlayDelay;
}) => {
  return (
    <OverlayTrigger
      placement={props.placement || 'left'}
      delay={props.delay}
      overlay={
        <Popover
          id="popover-basic"
          style={{
            minWidth: props.label.length > 100 ? 800 : undefined,
          }}
        >
          <Popover.Header as="h3" className="text-center">
            {props.title}
          </Popover.Header>
          <Popover.Body dangerouslySetInnerHTML={{ __html: props.label }} />
        </Popover>
      }
    >
      <Icon.InfoCircle
        className="icon-blue"
        // size={22}
        style={{ minWidth: 30 }}
      />
    </OverlayTrigger>
  );
};
